import { ValidatorRule, ValidatorStore } from './validation.interfaces';

/**
 * The purpose of this to serve validation stores
 * and provide system-wide validation.
 */
export class ValidationGlobalStore {
  private validationStores = new Map<string, ValidatorStore>();

  private _isDisposed: boolean;
  get isDisposed(): boolean {
    return this._isDisposed;
  }

  constructor() {}

  addStore(store: ValidatorStore, key: string) {
    this.validationStores.set(key, store);
  }

  /**
   * Get an existing store or if one does not exist, create, add, and return a new store.
   */
  getStore<TStore extends ValidatorStore>(key: string): TStore {
    let store = this.validationStores.get(key) as TStore;
    return store;
  }

  getRulesByMetadata(
    rulePredicate: (metadata: any) => boolean,
  ): ValidatorRule[] {
    let stores = [...this.validationStores.values()];
    let rules = stores.flatMap(s => s.getRulesByMetadata(rulePredicate));
    return rules;
  }

  validateByMetadata(rulePredicate: (metadata: any) => boolean) {
    var rules = this.getRulesByMetadata(rulePredicate);
    rules.forEach(r => r.validate());
  }

  get isValid(): boolean {
    let stores = [...this.validationStores.values()];
    let isValid = stores.every(s => s.isValid);
    return isValid;
  }

  dispose() {
    this._isDisposed = true;
    let stores = [...this.validationStores.values()];
    stores.forEach(s => s.dispose());
  }
}
